module.exports = __webpack_public_path__ + "static/media/pulsar.3199e9c2.png";